'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Image = require('react-bootstrap/lib/Image');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Image2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Image.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Image.js
 ** module chunks = 0
 **/